import { render, staticRenderFns } from "./izlemetablosu.vue?vue&type=template&id=7ce10702"
import script from "./izlemetablosu.vue?vue&type=script&lang=js"
export * from "./izlemetablosu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports